import React, { useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useHistory, useLocation } from 'react-router'
import { selectors as licenseSelectors } from 'store/licenseManager'
import { operations as reportsOperations } from 'store/reportsManager'
import { getTypeMap } from 'store/reportsManager/typeMap'
import HsUserProgress from './component'
import ContentEntryDataGetter from 'layers/content/Hocs/ContentEntryDataGetter'
import withApiError from 'layers/errorHandling/apiError/component'
import {
  ERROR_TYPE_CONTENTFUL,
  SHOW_CONTENT_ON_401,
} from 'layers/errorHandling/apiError'

const HsUserProgressContainer = ({
  activeAdminHsSites,
  resetSelectedProgram,
  selectedProgram,
  updateSelectedProgram,
}) => {
  const [siteId, setSiteId] = useState(null)
  const location = useLocation()
  const pageUrl = location.pathname.split('/').pop()
  const history = useHistory()
  const searchParams = useMemo(() => new URLSearchParams(location.search), [
    location.search,
  ])
  const matchingSite = activeAdminHsSites.find(site => site.id === siteId)
  const implementationLevel =
    matchingSite?.sitePreferences?.highSchool?.implementationLevel
  const isSetup = matchingSite?.sitePreferences?.highSchool?.isSetup
  const practiceTypeData = getTypeMap(pageUrl, implementationLevel)

  useEffect(() => {
    if (!selectedProgram) {
      updateSelectedProgram({ key: 'HS', name: 'HS' })
    }
    const searchParamsSiteId =
      searchParams.get('siteId') || activeAdminHsSites?.[0]?.id
    searchParams.set('siteId', searchParamsSiteId)
    history.replace({ search: searchParams.toString() })
    setSiteId(parseInt(searchParamsSiteId))
  }, [siteId])

  useEffect(() => {
    const cleanup = async () => {
      await resetSelectedProgram()
    }
    return cleanup
  }, [])

  return !siteId ? null : (
    <HsUserProgress
      isSetup={isSetup}
      practiceTypeData={practiceTypeData}
      siteId={siteId}
    />
  )
}

const mapStateToProps = state => {
  const {
    reportsManager: { selectedProgram },
  } = state
  const activeAdminHsSites = licenseSelectors.selectActiveAdminHsSites(state)

  return {
    activeAdminHsSites,
    selectedProgram,
  }
}

const mapDispatchToProps = {
  resetSelectedProgram: reportsOperations.resetSelectedProgram,
  updateSelectedProgram: reportsOperations.updateSelectedProgram,
}

const mapper = entry => {
  const { displayTitle, onboardingSnapshot } = entry || {}
  return {
    displayTitle,
    onboardingSnapshot,
  }
}

const options = {
  entryId: '5oqdbnI289AADFVmm2sJyx',
  include: 5,
  mapper,
  spread: true,
}

HsUserProgressContainer.propTypes = {
  activeAdminHsSites: PropTypes.array,
  resetSelectedProgram: PropTypes.func,
  selectedProgram: PropTypes.object,
  updateSelectedProgram: PropTypes.func,
}

export default ContentEntryDataGetter(
  withApiError(
    HsUserProgressContainer,
    [ERROR_TYPE_CONTENTFUL],
    [SHOW_CONTENT_ON_401],
  ),
  options,
  connect(mapStateToProps, mapDispatchToProps),
)
